var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.08,
    height: 92.08,
    viewBox: "0 0 92.08 92.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.04,
    cy: 46.04,
    r: 46.04,
    fill: "#ed3537"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.44,32.78a6.9,6.9,0,0,0-4.87-4.88C63.27,26.75,46,26.75,46,26.75s-17.23,0-21.53,1.15a6.9,6.9,0,0,0-4.87,4.88C18.49,37.07,18.49,46,18.49,46s0,9,1.15,13.26a6.92,6.92,0,0,0,4.87,4.88C28.81,65.33,46,65.33,46,65.33s17.23,0,21.53-1.15a6.92,6.92,0,0,0,4.87-4.88C73.59,55,73.59,46,73.59,46s0-9-1.15-13.26ZM40.53,54.31V37.77L54.85,46Z",
    fill: "#fdfdfd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.735c948ea20696ee0ab7500167a15603.svg";
export { ForwardRef as ReactComponent };